import BackgroundImage from 'gatsby-background-image';
import { getImage } from 'gatsby-plugin-image';
import { convertToBgImage } from 'gbimage-bridge';
import React, { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import DefaultImage from '../../../../../static/default-cover-image.jpg';
import { formatDateWithi18n } from '../../../../helpers/Formater';
import type { HeroPostProps } from './types';

const HeroPost: FC<HeroPostProps> = ({ post }) => {
    const { t } = useTranslation();
    const image = getImage(post.header_image.CloudinaryImageFromStrapi);
    const bgImage = convertToBgImage(image);

    const calculateMinutesOfReading = (content = '') => {
        const wordsPerMinute = 233;
        const words = content.split(' ').length;
        let readingtime = words / wordsPerMinute;
        readingtime = +readingtime.toFixed(1);
        return Math.round(readingtime);
    };

    return (
        <div className="bg-white">
            <div className="flex flex-wrap items-center">
                <div className="md:w-1/2 py-12 w-full">
                    <div className="md:w-full xl:w-2/3 pr-4 pl-4 md:mx-1/5 xl:mx-1/3 md:ml-auto content-center">
                        <div className="h-auto flex flex-col items-center content-center justify-center text-center capitalize">
                            <p className="text-gray-500 font-light">
                                <b>{formatDateWithi18n({ value: post.publishedAt })}</b>
                                <br />
                                <span>{`${calculateMinutesOfReading(post.content?.data?.content)} ${t('general.read', 'read')}`}</span>
                            </p>
                            <h4 className="pt-2 pb-4 text-3xl leading-10">{post.title}</h4>
                            <p className="text-gray-500 font-light">
                                {` ${post.authors?.length ? t('general.by', 'by') : ''} `}
                                <b>
                                    {!!post?.authors?.length &&
                                        post.authors.map((author) => ` ${author.first_name} ${author.last_name}`).join(', ')}
                                </b>
                            </p>
                        </div>
                    </div>
                </div>
                <div className="w-full md:w-1/2">
                    {post?.header_image?.CloudinaryImageFromStrapi ? (
                        <BackgroundImage
                            {...bgImage}
                            width="100%"
                            height="100%"
                            alt={`post display of ${post.title}`}
                            className="h-auto min-h-60"
                        />
                    ) : (
                        <div
                            style={{
                                backgroundImage: `url(${DefaultImage})`,
                            }}
                            className="h-auto min-h-60"
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default HeroPost;
